import React from 'react'
import { Table } from "antd";

const columns = [
  {
    title: "T2 - International Airport (P7 parking lot)",
    dataIndex: "name",
  },
];
const data = [
  {
    key: "1",
    name: "Mumbai Central",
  },
  {
    key: "2",
    name: "Khargar Station",
  },
];

const suggestedLocation = () => {
  return (
    <div className="searched-locations">
    <div>
      <Table columns={columns} dataSource={data} 
      size="small" />
    </div>
  </div>
  )
}

export default suggestedLocation